(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/graph/graph-model.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/graph/graph-model.js'); 
'use strict';

svs.sport.result_boxes.graph.GraphModel = Backbone.Model.extend({
  defaults: {
    isFinalized: false,
    numOfMatches: 0
  }
});

 })(window);